<template>

  <t-page>

    <CymacoQuoteWordServiceRunDialog :path="path" :item="wordServiceRunItem" @onSubmit="sendQueueWordReport(path,wordServiceRunPrimaryKey,'Orçamento')" :primary-key="wordServiceRunPrimaryKey" />

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  @click="msgInsertQuote"
                  primary/>

<!--        <t-button text="Relatórios"
                  @click="msgReports"
        />-->


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Orçamento, Cliente ..."
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

          <t-input-person customer
                          v-model="form.customerId"/>

          <t-input-search v-model="form.expeditionStatusId" :options="typeQuoteStatusOptions" select
                          label="Status Orçamento"/>

        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="quoteCodeLabel"
               primary-key-column="quoteNumber">

        <template #item(enterpriseAddressFull)="{item}">
          {{item.enterpriseAddressFull}}<span v-if="item.enterpriseNeighborhood !== '' && item.enterpriseNeighborhood.length > 0"> - {{item.enterpriseNeighborhood}}</span>
          <span v-if="objValid(item.enterpriseCity) && item.enterpriseCity.length > 0"> - {{item.enterpriseCity}}</span>
        </template>


        <template #item(statusQuote)="{item}">

          <div class="d-flex align-items-center">
              <span class="badge badge-dot badge-dot-xl mr-2"
                    :style="{'background-color': item.statusColor}"></span> {{ item.statusQuote }}
          </div>

        </template>

        <template #append-actions="{item}">

          <b-button
              v-if="getRenderRule('enableWordReport')"
              v-b-tooltip.hover.ds500 title="Gerar Orçamento no formato Word"
              @click="openDialogWordServiceRun(item,item.quoteId)"
              size="sm" variant="outline">
            <b-icon-file-word variant="primary"></b-icon-file-word>
          </b-button>

          <!--          <b-button
                        v-b-tooltip.hover.ds500 title="Impressão PDF"
                        @click="downloadReport(39, item.quoteId, 'orcamento_' + item.quoteCodeLabel,'pdf','Orçamento ' + item.quoteNumber, '&quoteId='+item.quoteId)"
                        size="sm" variant="outline">
                      <b-icon-file-pdf variant="primary"></b-icon-file-pdf>
                    </b-button>-->
        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";
import pageListEmbeddableMixin from "@/mixins/page/pageListEmbeddableMixin";
import ui from "@/assets/scripts/ui";
import CymacoQuoteWordServiceRunDialog from "@/views/custom/cymaco/CymacoQuoteWordServiceRunDialog.vue";

export default {
  mixins: [pageDefaultMixin, pageListMixin, pageListEmbeddableMixin],
  components: {CymacoQuoteWordServiceRunDialog},
  name: 'QuoteEmbeddable',
  data() {
    return {
      path: "business/quote", //Utilizar somente quando fora do padrão
      form: {
        customerId: 0,
        quoteStatusId: 0,
        sellerId: 0,
        paymentPlanId: 0,
        contactId: 0,
        companyId: 0,
        issueDate: "",
      },
      /*fields: [
        {key: "quoteNumber", label: "Cód. Orçamento"},
        {key: "customerNameAutomatically", label: "Cliente"},
        {key: "customerGroup", label: "Grupo"},
        {key: "customerCityFull", label: "Cidade/UF"},
        {key: "qtyItems", label: "Qtd. Itens"},
        {key: "amount", label: "Valor Total", formatter: "number"},
        {key: "statusQuote", label: "Status"},
        {key: "actions", label: ""},
      ],*/
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeQuoteStatusOptions: [],
      companyOptions: [],
      paymentPlanOptions: [],
      sellerOptions: [],

      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {

      delete this.form.status

      this.mountedPrepareEmbeddable()

    },
    async mountedContinued() {

      this.pageListIsLoaded = false

      await http.list(this.path + "/selectRelationList").then((response) => {

        this.typeQuoteStatusOptions = response.typeQuoteStatusOptions
        this.companyOptions = response.typeQuoteStatusOptions
        this.paymentPlanOptions = response.typeQuoteStatusOptions
        this.sellerOptions = response.typeQuoteStatusOptions

      }).catch(error => this.responseError(error))

      this.pageListIsLoaded = true

      await this.mountedContinuedEmbeddable() //Sempre no final

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela



    msgInsertQuote() {
      ui.msg(this, 'Inclusão de Orçamento Desabilitado', 'Sua conta esta configurada para inclusão de novos orçamentos somente via Inspeção Orçamentária. Desta forma para incluir um novo orçamento é necessário realizar a inspeção antes. Evitando inconsistência de informações')
    },


    msgReports() {
      ui.msg(this, 'Relatórios em Revisão', 'Relatórios de Orçamentos em processo de revisão')
    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
}
</script>
